import type { Theme } from '@mint-lib/theme';
import type {} from '@mint-lib/theme/src/extensions/button.js';
import type {} from '@mint-lib/theme/src/extensions/chip.js';
import type {} from '@mint-lib/theme/src/extensions/circularProgress.js';
import type {} from '@mint-lib/theme/src/extensions/palette.js';
import type {} from '@mint-lib/theme/src/extensions/typography.js';
import { styled, type CreateMUIStyled } from '@mui/material/styles';

export { Global, ThemeContext } from '@emotion/react';
export type { Keyframes, SerializedStyles } from '@emotion/react';
export type {
  StyledComponent,
  CSSObject,
  ComponentSelector,
} from '@emotion/styled';
export type { CSSProperties } from 'react';

export { default as isPropValid } from '@emotion/is-prop-valid';

export default styled as CreateMUIStyled<Theme>;

export {
  type Theme,
  css,
  keyframes,
  ThemeProvider,
  useTheme,
} from '@mui/material/styles';
